import getters from "@/study-search/store/getters";
import { PageTitleConstructor } from "@/study-search/models/page-title";
import { SearchStudyCardInfo } from "@/study-search/domain";
import { FaqBuilder } from "@/study-search/models/faq";
import { ref, Ref } from "vue";
import globals from "@/study-search/utils/globals";
import { BreadcrumbsFactory } from "@/study-search/domain/BreadcrumbsFactory";
import store from "@/study-search/store";
import { ProgrammeStructuredDataFactory, BreadcrumbDTO, PageTypes } from "@studyportals/fawkes/structured-data-seo";

export class SeoStructuredData {
	public structuredData: Ref<string> = ref('');

	public async mounted(): Promise<void> {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call
		const factory = new ProgrammeStructuredDataFactory(globals.currencyConversionService);

		const pageTitleConstructor = new PageTitleConstructor()
		const searchResults: SearchStudyCardInfo[] = getters.getSearchResults();
		const faqBuilder = new FaqBuilder();

		const data = JSON.stringify(await factory.buildStructuredData(
			pageTitleConstructor.getPageTitle(),
			pageTitleConstructor.getMetaDescription(),
			searchResults.map(result => result.card),
			await faqBuilder.build(),
			this.getBreadcrumbs(),
			true,
			PageTypes.SEARCH_RESULTS_PAGE
		));

		this.structuredData.value = `<script type="application/ld+json">${data}</script>`;

	}

	private getBreadcrumbs(): BreadcrumbDTO[] {
		const breadcrumbs = BreadcrumbsFactory.generateBreadcrumbs(store.getters.getFilters());

		return breadcrumbs.map((breadcrumb, index) => ({
			name: breadcrumb.name,
			position: index + 1,
			url: BreadcrumbsFactory.constructHref(breadcrumb)
		}));
	}
}
